var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vfc-day",
      class: _vm.isDisabledDate(_vm.day.date) ? "disabled" : "",
      on: {
        mouseover: _vm.dayMouseOver,
        click: function ($event) {
          return _vm.$parent.$parent.clickDay(_vm.day, _vm.isDisabledDate)
        },
      },
    },
    [
      _c("div", { staticClass: "vfc-day-wrapper" }, [
        _vm.startActive
          ? _c("div", { staticClass: "vfc-base-start" })
          : _vm._e(),
        _vm._v(" "),
        _vm.endActive ? _c("div", { staticClass: "vfc-base-end" }) : _vm._e(),
        _vm._v(" "),
        !_vm.day.hideLeftAndRightDays
          ? _c(
              "span",
              { class: _vm.getClassNames(_vm.day) },
              [
                _vm._t(
                  "default",
                  function () {
                    return [
                      _c("span", { staticClass: "vfc-day-date" }, [
                        _vm._v(_vm._s(_vm.day.day)),
                      ]),
                    ]
                  },
                  { week: _vm.week, day: _vm.day }
                ),
                _vm._v(" "),
                _vm.timesShow
                  ? _c(
                      "span",
                      { staticClass: "times", on: { click: _vm.clearRange } },
                      [_vm._v("×")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.numberShow
                  ? _c(
                      "span",
                      {
                        staticClass: "number",
                        on: {
                          mouseover: function ($event) {
                            _vm.toolTip && (_vm.onNumber = true)
                          },
                          mouseleave: function ($event) {
                            _vm.onNumber = false
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.getDaysNumber) + "\n        "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.toolTip && _vm.onNumber,
                                expression: "toolTip && onNumber",
                              },
                            ],
                            staticClass: "toolTip",
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.toolTipTxt().join(" ")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }